module.exports = __webpack_public_path__ + "static/media/card-2.a53d1b4b.svg";